<template>
    <div class="p-6 sm:p-8">
        <p class="text-sm text-taupe-600 mb-6">
            Choose the SDK for your language or framework to get started.
        </p>
        <section
            v-for="(group, index) in groups"
            :key="group.title ?? 'all'"
            :class="{ 'mt-8': index > 0 }"
        >
            <h3
                v-if="group.title"
                class="font-sans text-xs font-medium uppercase tracking-wide text-taupe-500 mb-3"
            >
                {{ group.title }}
            </h3>
            <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
                <button
                    v-for="sdk in group.sdks"
                    :key="sdk.id"
                    type="button"
                    class="cursor-pointer flex flex-col items-center gap-3 rounded-xl border-2 border-taupe-200 p-6 text-center transition-all hover:border-sky-400 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-sky-500"
                    @click="$emit('select', sdk)"
                >
                    <svg
                        viewBox="0 0 24 24"
                        class="h-10 w-10"
                        :fill="'#' + sdk.icon.hex"
                        aria-hidden="true"
                    >
                        <path :d="sdk.icon.path" />
                    </svg>
                    <span class="text-sm font-medium text-taupe-800">
                        {{ sdk.label }}
                    </span>
                </button>
            </div>
        </section>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    // Each SDK may carry a `group` (e.g. "Backend", "Web"). Groups appear in the order their
    // first SDK appears, and SDKs keep their order within a group. SDKs without a group
    // render as one ungrouped list.
    sdks: {
        type: Array,
        required: true,
    },
})

const groups = computed(() => {
    const byTitle = new Map()

    for (const sdk of props.sdks) {
        const title = sdk.group ?? null
        if (!byTitle.has(title)) byTitle.set(title, [])
        byTitle.get(title).push(sdk)
    }

    return [...byTitle].map(([title, sdks]) => ({ title, sdks }))
})

defineEmits(['select'])
</script>
